var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFutureForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.20312,
    y: 4.1543,
    width: 8.575,
    height: 8.575,
    stroke: "#2D432D",
    strokeWidth: 1.8375,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9297,
    y: 3.19336,
    width: 8.575,
    height: 8.575,
    transform: "rotate(15 17.9297 3.19336)",
    stroke: "#2D432D",
    strokeWidth: 1.8375,
    strokeLinecap: "square"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.20312,
    y: 17.6309,
    width: 8.575,
    height: 8.575,
    stroke: "#2D432D",
    strokeWidth: 1.8375,
    strokeLinecap: "square"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6719,
    y: 17.6309,
    width: 8.575,
    height: 8.575,
    stroke: "#2D432D",
    strokeWidth: 1.8375,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureForwardIcon);
export default __webpack_public_path__ + "static/media/FutureForwardIcon.2cf2afc8b338fee2c2bcbae5fb944b30.svg";
export { ForwardRef as ReactComponent };